import { render, staticRenderFns } from "./InputMoney.vue?vue&type=template&id=b2ad7cfc&scoped=true&"
import script from "./InputMoney.vue?vue&type=script&lang=ts&"
export * from "./InputMoney.vue?vue&type=script&lang=ts&"
import style0 from "./InputMoney.vue?vue&type=style&index=0&id=b2ad7cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ad7cfc",
  null
  
)

export default component.exports